import React from 'react';
import cx from 'classnames';

import { Icon, MaterialSymbol } from "ui/material-symbols";
import { useRichTextEditorCommands } from "ui/control/richtexteditor/rich-text-editor-commands-context";
import "./RichTextEditorButton.css";

interface Props {
    icon: MaterialSymbol;
    iconSize?: number;
    title: string;
    hotkey?: string;
    className?: string;
    active?: boolean;
    disabled?: boolean;
    onClick?: (event: React.MouseEvent) => void;
    command?: () => void;
    ref?: React.Ref<HTMLButtonElement>;
}

export function RichTextEditorButton(
    {icon, iconSize = 24, title, hotkey, className, active, disabled, onClick, command, ref}: Props
) {
    const {focus} = useRichTextEditorCommands();

    const onCommandClick = (event: React.MouseEvent) => {
        command && command();
        focus();
        event.preventDefault();
    }

    return (
        <button type="button" className={cx("rich-text-editor-button", className, {active})} disabled={disabled}
                title={hotkey ? `${title} (${hotkey})` : title} onClick={onClick ?? onCommandClick} ref={ref}>
            {icon && <Icon icon={icon} size={iconSize}/>}
        </button>
    );
}
